import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  isAuthenticated: boolean | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    fetchAuthStart(state) {
      state.loading = true;
      state.error = null;
    },
    setAuthData(state) {
      state.isAuthenticated = true;
      state.loading = false;
    },
    fetchAuthError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetAuthState: () => initialState,
  },
});

export const { fetchAuthStart, setAuthData, fetchAuthError, resetAuthState } = authSlice.actions;

export default authSlice.reducer;
